import React from 'react';

export const ReloadIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.333008 13.6667V7.83332H6.16634L3.48551 10.5167C4.41047 11.4625 5.67673 11.997 6.99967 12C9.11588 11.9969 11.0009 10.6618 11.7063 8.66665H11.7213C11.8168 8.3955 11.889 8.11672 11.9372 7.83332H13.6138C13.1939 11.1666 10.3593 13.6665 6.99967 13.6667H6.99134C5.22364 13.6719 3.52731 12.9698 2.28051 11.7167L0.333008 13.6667ZM2.06134 6.16665H0.384674C0.804466 2.83466 3.63717 0.335106 6.99551 0.333286H6.99967C8.7677 0.327629 10.4644 1.02985 11.7113 2.28332L13.6663 0.333286V6.16665H7.83301L10.518 3.48332C9.59208 2.53636 8.32409 2.00177 6.99967 1.99999C4.88347 2.00311 2.99841 3.33814 2.29301 5.33332H2.27801C2.1818 5.60424 2.10958 5.88309 2.06217 6.16665H2.06134Z"
      fill="white"/>
  </svg>)

